import { render, staticRenderFns } from "./ReportesGenerales.vue?vue&type=template&id=3f024cfe&scoped=true"
import script from "./ReportesGenerales.vue?vue&type=script&lang=js"
export * from "./ReportesGenerales.vue?vue&type=script&lang=js"
import style0 from "./ReportesGenerales.vue?vue&type=style&index=0&id=3f024cfe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f024cfe",
  null
  
)

export default component.exports